import { getMessages } from 'app/store/constants';

export const FAKE_NOTIFICATION_CARD = getMessages().getText('notifications.fake.card');
export const FAKE_NOTIFICATION_BOARD = getMessages().getText('notifications.fake.board');
export const FAKE_NOTIFICATION_LIST = getMessages().getText('notifications.fake.list');
export const FAKE_NOTIFICATION_DATE = getMessages().getText('notifications.fake.date');

export const FAKE_NOTIFICATIONS = [
    {
        icon: 'overdue',
        title: getMessages().getText('notifications.fake.overdue.title'),
        text: getMessages().getText('notifications.fake.overdue.text'),
        isHighlight: true,
    },
    {
        icon: 'arrow-circle',
        title: getMessages().getText('notifications.fake.assign.title'),
        text: getMessages().getText('notifications.fake.assign.text'),
    },
    {
        icon: 'comment',
        title: getMessages().getText('notifications.fake.comment.title'),
        text: getMessages().getText('notifications.fake.comment.text'),
    },
    {
        icon: 'mention',
        title: getMessages().getText('notifications.fake.mention.title'),
        text: getMessages().getText('notifications.fake.mention.text'),
    },
    {
        icon: 'attachment',
        title: getMessages().getText('notifications.fake.attachment.title'),
        text: getMessages().getText('notifications.fake.attachment.text'),
    },
]
